import React, { useState } from 'react';
import {
  Edit,
  TextInput,
  DateInput,
  SimpleForm,
  required,
  SaveButton,
  Toolbar,
  translate
} from 'react-admin';
import { Box, Button } from '@material-ui/core';
import { useLocale } from 'react-admin';

const QuoteEditToolbar = translate(({ onCancel, translate, ...props }) => (
  <Toolbar {...props}>
    <SaveButton />
    <Button m={5} onClick={onCancel}>{translate('ra.action.cancel')}</Button>
  </Toolbar>
));

const QuoteEdit = ({ onCancel, ...props }) => {
  const locale = useLocale();

  return (
  <Edit title=" " {...props}>
    <SimpleForm toolbar={<QuoteEditToolbar onCancel={onCancel} />}>
      <TextInput source="id" disabled />
      <TextInput source="text" validate={required()} />
      <TextInput source="author" />
    </SimpleForm>
  </Edit>
)};

export default QuoteEdit;
